import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import TopNavbarBack from "../../components/TopNavbarBack";
import LoadingPage from "../../components/LoadingPage";
import EmptyPage from "../../components/EmptyPage";
import GoToTop from "../../components/GoToTop";
import { baseURL, useFetch } from "../../custom/api";
import ChallengeProgress from "./components/ChallengeProgress";
import ChallengeStartModal from "./components/ChallengeStartModal";
import ChallengeRules from "./components/ChallengeRules";
import Leaderboard from "./components/Leaderboard";
import mealTypeLabels from "./mealTypeLabels";
import "../../styles/Containers.css";
import "../../styles/Banners.css";
import "../../styles/Challenges.css";

export default function ChallengeDetails() {
  const { id } = useParams();
  const { myFetch } = useFetch();
  const [data, setData] = useState(undefined); // undefined = loading, null = not found
  const [progress, setProgress] = useState(null);
  const [showStart, setShowStart] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadDetails = useCallback(async () => {
    const resp = await myFetch(`challenges/${id}`, { method: "GET" });
    const r = await resp.json();
    setData(r && r.status === "success" ? r : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const loadProgress = useCallback(async () => {
    const resp = await myFetch(`challenges/${id}/progress`, { method: "GET" });
    const r = await resp.json();
    if (r.status === "success") setProgress(r);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    loadDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (data?.participation) loadProgress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.participation?.status]);

  if (data === undefined) return <LoadingPage />;
  if (data === null) return <EmptyPage caption="این چالش پیدا نشد" />;

  const { challenge, participation, items_preview } = data;
  const handleChanged = () => {
    loadDetails();
    loadProgress();
    setRefreshKey((k) => k + 1);
  };

  return (
    <div className="grey-background">
      <TopNavbarBack
        title={challenge.title}
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["icon-iconinfo"]}
        lbackground={["rectangle1"]}
        lfunction={() => setShowRules(true)}
      />

      <div className="main-container">
        {challenge.banner_image && (
          <img
            src={`${baseURL}/${challenge.banner_image}`}
            alt={challenge.title}
            className="width100 radius2"
          />
        )}

        <div className="rightAlign">
          <p className="heading-2">{challenge.title}</p>
          <p className="caption-1 grey-2 yekan marginTop5">
            {challenge.short_description}
          </p>
        </div>

        {participation ? (
          progress && (
            <ChallengeProgress
              challenge={progress.challenge}
              participation={progress.participation}
              progress={progress.progress}
              onChanged={handleChanged}
            />
          )
        ) : (
          <>
            <p className="yekan grey-1 rightAlign">{challenge.description}</p>

            <div className="gap2">
              <div className="challengeStepCard">
                <span className="challengeStepNumber">1</span>
                <p className="yekan grey-1">غذاها رو به تقویمت اضافه کن</p>
              </div>
              <div className="challengeStepCard">
                <span className="challengeStepNumber">2</span>
                <p className="yekan grey-1">هر روز که انجامش دادی، تیک بزن</p>
              </div>
            </div>

            <div className="challengeProgressCard rightAlign">
              <p className="subject-1 grey-1 marginBottom1r" style={{ fontWeight: "bold" }}>
                امتیازدهی
              </p>
              <p className="caption-1 grey-2 yekan">
                شروع چالش: {challenge.start_points}+ امتیاز · هر تیک روزانه: {challenge.daily_points}+
                امتیاز
              </p>
            </div>

            {items_preview && items_preview.length > 0 && (
              <div className="rightAlign">
                <p className="heading-3 marginBottom1r">پیش‌نمایش وعده‌ها</p>
                {items_preview.map((it, i) => (
                  <div className="spc-between marginBottom1r" key={i}>
                    <span className="caption-1 grey-2 yekan">
                      روز {it.day_number} - {mealTypeLabels[it.meal_type] || it.meal_type}
                    </span>
                    <span className="caption-1 grey-1 yekan">{it.recipe_name}</span>
                  </div>
                ))}
              </div>
            )}

            {challenge.display_status === "published" && (
              <div className="challengeStartFixed">
                <a
                  className="fill-container radius1-5"
                  onClick={() => setShowStart(true)}
                >
                  شروع چالش
                </a>
              </div>
            )}
            {challenge.display_status !== "published" && (
              <p className="caption-1 grey-2 centerAlign yekan">
                این چالش الان برای شروع در دسترس نیست
              </p>
            )}
          </>
        )}

        <div className="rightAlign" style={{ paddingBottom: "6rem" }}>
          <p className="heading-3 marginBottom1r">لیدربورد</p>
          <Leaderboard challengeId={challenge.challenge_id} refreshKey={refreshKey} />
        </div>
      </div>

      <GoToTop />

      <ChallengeStartModal
        show={showStart}
        onClose={() => setShowStart(false)}
        challenge={challenge}
        onStarted={handleChanged}
      />
      <ChallengeRules show={showRules} onClose={() => setShowRules(false)} challenge={challenge} />
    </div>
  );
}
